
<template>
    <v-app >

        <v-dialog
            v-model="dialog_error"
            max-width="800"
            style
        >   <v-card class="pa-8">
            <v-icon class="text-h1" color="red">mdi-close</v-icon>
            <div class="text-h6 mt-4">{{ error_text_1 }}</div>
            <div class="text-h7 ml-2 mr-2 mt-2">{{ error_text_2 }}</div>
            <div class="text-center mt-16">
                <v-btn outlined style="color:black" rounded color="grey" @click="dialog_error=false">
                <v-icon left>mdi-close</v-icon>ปิด</v-btn>
            </div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_address"
            max-width="600"
            style
            eager
        ><v-card class="pa-2">
            <v-text-field
                class="mb-2 mt-2"
                v-model="zipcode"
                label="ค้นหาจากรหัสไปรษณีย์"
                outlined
                dense
                hide-details
                ref="ref_zipcode"
                @input="seach_zipcode"
            ></v-text-field>
            <v-list align="left">
                <v-list-item
                    v-for="(item,i) in zipcode_list"
                    :key="i"
                    class="text-subtitle-2 pt-n2 pb-n2"
                    style="border: solid;border-width: thin;border-color: lightgrey;"
                    @click="selectAddress(item)"
                >
                    <div>
                    {{ item }}
                    </div>
                </v-list-item>
            </v-list>
        </v-card>
        </v-dialog>

        <div class="ma-4" align="left">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
                <div class="text-h6 mb-6">
                    <v-icon>mdi-pencil-box-outline</v-icon>สั่งจองชุด Antigen Self Test Kit
                </div>
                <v-card class="pa-2 mb-3" style="border: solid;">ชื่อผู้จอง
                    <v-text-field
                        v-model="order_name"
                        :rules="rule_requied"
                        outlined
                        dense
                        hide-details
                        @input="auto_name_process()"
                    ></v-text-field>
                </v-card>
                <v-card class="pa-2 mb-3" style="border: solid;">ที่อยู่ในการจัดส่ง
                    <v-row class="mb-n4 mt-n3">
                        <v-col cols="7">
                            <v-text-field
                                class="mb-2 mt-2"
                                v-model="reciver_name"
                                :rules="rule_requied"
                                label="ชื่อผู้รับ"
                                outlined
                                dense
                                hide-details
                                :disabled="is_auto_reciver_name"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="5" >
                            <v-checkbox
                                v-model="is_auto_reciver_name"
                                hide-details
                                @change="auto_name_process()"
                            ><template v-slot:label><div class="text-caption">ชื่อเดียวกับผู้จอง</div></template></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-text-field
                        class="mb-2 mt-2"
                        label="เบอร์โทร"
                        v-model="reciver_tel"
                        :rules="rule_requied"
                        outlined
                        dense
                        hide-details
                    ></v-text-field>
                    <v-text-field
                        class="mb-2 mt-2"
                        v-model="reciver_address_1"
                        :rules="rule_requied"
                        label="บ้านเลขที่ อาคาร"
                        outlined
                        dense
                        hide-details
                        @input="auto_address_process(auto_address)"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        label="ซอย หมู่ ถนน"
                        v-model="reciver_address_2"
                        outlined
                        dense
                        hide-details
                        @input="auto_address_process(auto_address)"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        label="แขวง/ตำบล เขต/อำเภอ จังหวัด รหัสไปรษณีย์"
                        v-model="reciver_address_3"
                        :rules="rule_requied"
                        outlined
                        dense
                        hide-details
                        @click="open_dialog_address('reciver_address_3')"
                        @input="auto_address_process(auto_address)"
                    ></v-text-field>
                </v-card>
                 <v-card class="pa-2 mb-3" style="border: solid;">
                    <v-checkbox
                        class="mt-n1"
                        v-model="is_taxinvoice"
                        label="ขอรับใบกำกับภาษีทางอีเมล"
                        hide-details
                    ></v-checkbox>
                    <div v-if="is_taxinvoice">
                        <v-checkbox
                            v-model="is_auto_tax_name"
                            label="ชื่อเดียวกับผู้จอง"
                            hide-details
                            @change="auto_name_process"
                            :disabled="!is_taxinvoice"
                        ></v-checkbox>
                        <v-checkbox
                            class="mt-n1"
                            v-model="is_auto_tax_address"
                            label="ที่อยู่เดียวกับที่ส่งสินค้า"
                            hide-details
                            @change="auto_address_process"
                            :disabled="!is_taxinvoice"
                        ></v-checkbox>
                        <v-text-field
                            class="mb-2 mt-2"
                            label="ชื่อผู้เสียภาษี"
                            v-model="tax_name"
                            :rules="rule_requied"
                            outlined
                            dense
                            hide-details
                            :disabled="is_auto_tax_name||!is_taxinvoice"
                        ></v-text-field>
                        <v-text-field
                            class="mb-2"
                            v-model="tax_id"
                            label="เลขผู้เสียภาษี/เลขประจำตัวประชาชน"
                            :rules="rule_requied.concat(rule_13digit)"
                            outlined
                            dense
                            hide-details
                            :disabled="!is_taxinvoice"
                        ></v-text-field>
                        <v-text-field
                            class="mb-2"
                            label="บ้านเลขที่ อาคาร"
                            v-model="tax_address_1"
                            :rules="rule_requied"
                            outlined
                            dense
                            hide-details
                            :disabled="is_auto_tax_address||!is_taxinvoice"
                        ></v-text-field>
                        <v-text-field
                            class="mb-2"
                            label="ซอย หมู่ ถนน"
                            v-model="tax_address_2"
                            outlined
                            dense
                            hide-details
                            :disabled="is_auto_tax_address||!is_taxinvoice"
                        ></v-text-field>
                        <v-text-field
                            class="mb-2"
                            label="แขวง/ตำบล เขต/อำเภอ จังหวัด รหัสไปรษณีย์"
                            v-model="tax_address_3"
                            :rules="rule_requied"
                            outlined
                            dense
                            hide-details
                            @click="open_dialog_address('tax_address_3')"
                            :disabled="is_auto_tax_address||!is_taxinvoice"
                        ></v-text-field>
                        <v-text-field
                            class="mb-2"
                            label="อีเมลสำหรับรับใบกำกับภาษี"
                            v-model="tax_email"
                            :rules="rule_requied"
                            outlined
                            dense
                            hide-details
                            :disabled="!is_taxinvoice"
                        ></v-text-field>
                    </div>
                    </v-card>
                <v-card class="pa-2 mb-3" style="border: solid;">จำนวนสั่งจองชุด Antigen Self Test Kit
                    <v-select
                        class="mb-2 mt-2"
                        :items="pricelist"
                        v-model="price_select"
                        :rules="rule_requied"
                        item-text="text"
                        item-value="value"
                        label="จำนวน"
                        outlined
                        dense
                        hide-details
                    ></v-select>
                    <div v-if="price_select">
                        <div class="text-subtitle-2">ราคาสินค้า {{ price_select ? pricelist[price_select[1]].item_price : "" }} บาท</div>
                        <div class="text-subtitle-2">ค่าขนส่ง {{ price_select ? pricelist[price_select[1]].item_fee : "" }} บาท</div>
                        <div><b>รวมที่ต้องจ่าย {{ pricelist[price_select[1]].item_price + pricelist[price_select[1]].item_fee }} บาท</b></div>
                    </div>
                </v-card>

                <v-card class="pa-2 mb-3" style="border: solid;">หมายเหตุ
                    <v-text-field
                            class="mb-2"
                            v-model="note"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                </v-card>
                <div align="center">
                    <v-btn  color="#00E4FF" class="pa-5 text-h5 ma-2" width="80%" @click="confirm" :disabled="!valid">
                        {{ $t('registerform_submit') }}
                    </v-btn>
                </div>
            </v-form>
        </div>
    </v-app>
</template>


<script>

import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'
import App from '@/models/instance/App'
import Formrule from '@/models/Formrule';

export default {
  props: ['nextstep'],
  data () {
    return {

        countries : []
        ,valid: true

        ,order_name : ""

        ,is_auto_reciver_name : false

        ,reciver_name : ""
        ,reciver_tel : ""
        ,reciver_address_1 : ""
        ,reciver_address_2 : ""
        ,reciver_address_3 : ""

        ,pricelist : []
        ,price_select : undefined

        ,is_taxinvoice : false
        ,is_auto_tax_name : false
        ,is_auto_tax_address : false

        ,tax_name : ""
        ,tax_id : ""
        ,tax_address_1 : ""
        ,tax_address_2 : ""
        ,tax_address_3 : ""
        ,tax_email : ""

        ,note : ""

        ,dialog_address : false
        ,zipcode : ""
        ,zipcode_list : []
        ,tmp_field : ""

        ,dialog_error : false
        ,error_text_1 : ""
        ,error_text_2 : ""
        ,...Formrule
    }
  },
  mounted : function () {
    var que1 = this.$store.commit('addLoading')
    axios.get('https://gist.githubusercontent.com/ChaiyachetU/a72a3af3c6561b97883d7af935188c6b/raw/0e9389fa1fc06b532f9081793b3e36db31a1e1c6/thailand.json')
    .then(response => {
        this.$store.commit('finishLoading',que1)
        this.countries = response.data
    })

    var que2 = this.$store.commit('addLoading')
    axios.post(config.api.url.line.specialmarket.get_price,{},{ headers: Member.getTokenHeader()})
    .then(response => {
        this.$store.commit('finishLoading',que2)
        this.pricelist = response.data
        this.pricelist.forEach((p,i,arr)=>{
            arr[i]['text'] = p.product_name + ' ' + p.item_name
            arr[i]['value'] = [p.product_id,i]
        })
    })
    var que3 = this.$store.commit('addLoading')
    axios.post(config.api.url.line.specialmarket.get_lastinput,{app_id:App.getAppId()},{ headers: Member.getTokenHeader()})
    .then(response => {
        this.$store.commit('finishLoading',que3)
        Object.keys(response.data).forEach(k=>{
            if(k in this){
                this[k] = response.data[k]
            }
        })
    })
  },
  methods : {
      confirm(){
        this.valid = this.$refs.form.validate()
        if(this.valid==true){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.line.specialmarket.order
            ,{ 
                app_id:App.getAppId()
                ,order_name : this.order_name
                ,is_auto_reciver_name : this.is_auto_reciver_name
                ,reciver_name : this.reciver_name
                ,reciver_tel : this.reciver_tel
                ,reciver_address_1 : this.reciver_address_1
                ,reciver_address_2 : this.reciver_address_2
                ,reciver_address_3 : this.reciver_address_3
                ,is_taxinvoice : this.is_taxinvoice
                ,is_auto_tax_name : this.is_auto_tax_name
                ,is_auto_tax_address : this.is_auto_tax_address
                ,tax_name : this.tax_name
                ,tax_id : this.tax_id
                ,tax_address_1 : this.tax_address_1
                ,tax_address_2 : this.tax_address_2
                ,tax_address_3 : this.tax_address_3
                ,tax_email : this.tax_email
                ,note : this.note
                ,product_id : this.pricelist[this.price_select[1]].product_id
                ,item_name : this.pricelist[this.price_select[1]].item_name
                ,item_piece : this.pricelist[this.price_select[1]].item_piece
                ,item_price : this.pricelist[this.price_select[1]].item_price
                ,item_fee : this.pricelist[this.price_select[1]].item_fee
            }
            ,{ headers: Member.getTokenHeader()})
            .then(response => {
                this.$store.commit('finishLoading',que)
                console.log(response.data)
                if(response.data.isSuccess){
                    this.$router.replace({
                            name:"SpecialMarketOrderSuccess",params: { 
                            order_id:response.data.order_id
                        }
                    })
                }else{
                    this.dialog_error = true
                    if(response.data.error=='overlimit'){
                        this.error_text_1 = "เกินจำนวนที่สั่งได้"
                        this.error_text_2 = "สามารถสั่งได้อีกไม่เกิน " + response.data.error_extra + " ชิ้น"
                    }
                    else if(response.data.error=='reachlimit'){
                        this.error_text_1 = "มีผู้สั่งซื้อครบจำนวนแล้ว"
                        this.error_text_2 = "หากมีการเพื่มจำนวนสินค้าในคลัง จะมีการประกาศให้ทราบผ่านทางช่องทางต่างๆ"
                    }else{
                        this.error_text_1 = "เกิดข้อผิดพลาด"
                        this.error_text_2 = "กรุณารอซักครู่ หรือออกแล้วลองใหม่"
                    }
                    
                }
            })
        }
      },
      auto_name_process(){
          if(this.is_auto_reciver_name){
              this.reciver_name = this.order_name
          }
          if(this.is_auto_tax_name){
              this.tax_name = this.order_name
          }
      },
      auto_address_process(){
          if(this.is_auto_tax_address){
              this.tax_address_1 = this.reciver_address_1
              this.tax_address_2 = this.reciver_address_2
              this.tax_address_3 = this.reciver_address_3
          }
      },
      open_dialog_address(field){
        this.tmp_field=field;
        this.dialog_address=true;
      },
      seach_zipcode(){
          this.zipcode_list = this.countries.filter(c=>c.zipcode == this.zipcode).map(d=>d.district + ' ' + d.amphoe + ' ' + d.province + ' ' + d.zipcode)
      },
      selectAddress(value){
          this[this.tmp_field] = value
          this.dialog_address = false
      }
  },
}
</script>